import { ObservableArray, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerSideDataLoader } from "uicomponents";
import { WarehouseKeeping, WarehouseKeepingListViewModel } from "./warehouseKeepingList-viewModel";

export class WarehouseKeepingListView extends View<WarehouseKeepingListViewModel>{
    GetViewUniqueId(): string {
        return "V-73246AC4-E130-416F-9606-7AEF62C00562"
    }
    loadHtml(): string {
        let element = require('./warehouseKeepingList.html').default;
        let style = require('./warehouseKeepingList.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set warehouseKeepings(v: ObservableArray<WarehouseKeeping>) { this._warehouseKeepings = v; } public get warehouseKeepings(): ObservableArray<WarehouseKeeping> { return this._warehouseKeepings;} private _warehouseKeepings: ObservableArray<WarehouseKeeping>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup;} private _popup: IPopup;  
 
    createWarehouseKeeping () {
        this.dataContext.createWarehouseKeeping();
    }
 
    createWarehouseKeepingReport () {
        this.dataContext.createWarehouseKeepingReport();
    }
}
